var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "attendance-wrapper" },
    [
      _c("el-row", { staticClass: "section-row dashboard-header-row" }, [
        _c("div", { staticClass: "dashboard-header" }, [
          _c("span", { staticClass: "custom-date" }, [
            _c("i", { staticClass: "el-icon-s-claim" }),
            _vm._v(_vm._s(_vm.formattedDate)),
          ]),
        ]),
      ]),
      _c(
        "el-row",
        { staticClass: "section-row", attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [_c("AttendanceStatistics")],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "section-row", attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 8, lg: 6 } },
            [_c("StatusChart")],
            1
          ),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 16, lg: 18 } },
            [_c("AttendanceStatusChart")],
            1
          ),
        ],
        1
      ),
      _vm.checkPermission(["studentQuality_ablum"])
        ? _c(
            "el-row",
            { staticClass: "section-row", attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [_c("AlbumStatisticsCard")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.checkPermission(["fees_2_finance_tuition_statistics"])
        ? _c(
            "el-row",
            {
              staticClass: "section-row tuition-chart-row",
              attrs: { gutter: 16 },
            },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                [_c("TuitionBillChart")],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                [_c("TuitionBillSummaryChart")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.checkPermission(["studentQuality_attendance"]) ||
      _vm.checkPermission(["attendance_v4"])
        ? _c(
            "el-row",
            { staticClass: "section-row", attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [_c("ClassAttendanceTableCard")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }